import styled from 'styled-components';
import COLORS from '../../style/universal.color';
import { ResponsiveType } from 'react-multi-carousel/lib/types';
import { ResponsiveLayoutItem } from './carousel.types';

const { mlbGrey1, mlbGrey2, mlbGrey6 } = COLORS;

export const buildButtonStyles = (heightDifference: number, left: boolean): string => `
    ${left ? 'left: 0px;' : 'right: 0px;'}
    position: absolute;
    top: calc(50% - ${heightDifference}px);
    outline: none;
    svg {
      use {
        symbol {
          path {
            fill: #aaa;
          }
        }
      }
    }
    &:hover {
      background-color: transparent;
    }
  `;

// Props for the dot styled component
interface DotProps {
  active?: boolean;
}

// Props for the carousel styled component
interface CarouselProps {
  arrowsOutside: boolean;
  removeArrowAtWidth: string[];
  layout: ResponsiveType;
  arrowHeight: number;
  dark: boolean;
}

// Build the styles to hide the arrows at certain breakpoints
const buildHideString = (layout: ResponsiveType, removeArrowAtWidth: string[]): string => {
  let arrowHideString = '';
  for (let i: number = 0; i < removeArrowAtWidth.length; i++) {
    const layoutObj: ResponsiveLayoutItem = layout[removeArrowAtWidth[i]];
    if (layoutObj) {
      const minWidth: number = layoutObj.breakpoint.min;
      const maxWidth: number = layoutObj.breakpoint.max;
      arrowHideString += `
        @media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px) {
          button {
            display: none;
          }
        }
      `;
    }
  }
  return arrowHideString;
};

// Styled component for each pagination dot
export const StyledDotSVG = styled.svg<DotProps>`
  fill: ${mlbGrey1};
  opacity: ${({ active }) => (active ? 1 : 0.6)};
  margin: 4px 4px 10px 4px;
  &:hover {
    cursor: pointer;
  }
`;

// Styled component for the carousel
export const StyledCarousel = styled.div<CarouselProps>`
  ${({ arrowsOutside }) =>
    arrowsOutside &&
    `
    .react-multi-carousel-list {
      width: calc(100% - 60px);
      margin: 0 30px;
    }`}
  position: relative;
  ${({ layout, removeArrowAtWidth }) => buildHideString(layout, removeArrowAtWidth)}

  .left-button {
    padding-left: 3px;
    ${({ arrowHeight }) => buildButtonStyles(arrowHeight / 2, true)}
  }
  .right-button {
    padding-right: 3px;
    ${({ arrowHeight }) => buildButtonStyles(arrowHeight / 2, false)}
  }
  button {
    &:disabled {
      svg {
        use {
          symbol {
            path {
              fill: ${({ dark }) => (dark ? mlbGrey6 : mlbGrey2)};
            }
          }
        }
      }
      background-color: transparent;
    }
  }
`;
